import React, { useEffect, useState } from 'react';
import * as RToast from '@radix-ui/react-toast';
import { CrossIcon } from '../../index';

interface IToastProps {
	actionItem?: React.ReactNode;
	content?: React.ReactNode;
	className?: string;
	duration?: number;
	filledIconColor?: string;
	icon?: React.ReactNode;
	position?: 'top' | 'bottom';
	onToastFinished?: () => void;
}

enum EPositionAnimation {
	top = 'animate-slideIn md:animate-slideInBottom',
	bottom = 'animate-slideInBottomToast md:animate-slideInBottom',
}

enum EPosition {
	top = 'top-8',
	bottom = 'bottom-[140px]',
}

export const Toast = ({
	actionItem,
	className,
	content,
	duration = 5000,
	filledIconColor,
	icon,
	position = 'top',
	onToastFinished = () => {},
}: IToastProps) => {
	const [openToast, setOpenToast] = useState(true);

	useEffect(() => {
		let timeoutId: NodeJS.Timeout | undefined;
		if (onToastFinished) {
			timeoutId = setTimeout(() => {
				onToastFinished();
			}, duration);
		}
		return () => {
			if (timeoutId) {
				clearTimeout(timeoutId);
			}
		};
	}, []);

	return (
		<>
			<RToast.Root
				className={`flex justify-between items-center gap-4 bg-gray-200 text-white rounded py-3 px-5 ${
					openToast && `${EPositionAnimation[position]}`
				}`}
				duration={duration}
				open={openToast}
				onOpenChange={setOpenToast}>
				<RToast.Title>
					{filledIconColor ? (
						<span className={`inline-flex rounded-half p-1 bg-${filledIconColor}`}>{icon}</span>
					) : (
						icon
					)}
				</RToast.Title>
				<span className="flex flex-col gap-2">
					<RToast.Description className="font-sans text-base">{content}</RToast.Description>
					{actionItem && (
						<RToast.Action asChild className="cursor-pointer" altText="ActionBtn">
							{actionItem}
						</RToast.Action>
					)}
				</span>
				<RToast.Close
					aria-label="Close"
					className="bg-gray-200 border-none cursor-pointer transition-opacity opacity-80 hover:opacity-100"
					onClick={() => onToastFinished()}>
					<CrossIcon fill="#FFF" />
				</RToast.Close>
			</RToast.Root>
			<RToast.Viewport
				className={`fixed ${EPosition[position]} left-1.5 right-1.5 z-[2998] md:top-auto md:bottom-1.5 md:max-w-[360px] ${className}`}
			/>
		</>
	);
};

interface IToastProviderProps {
	children?: React.ReactNode;
}

export const ToastProvider = ({ children }: IToastProviderProps) => (
	<RToast.Provider swipeDirection="down">{children}</RToast.Provider>
);
